// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { myInvitationsQueryOptions } from "@/app/invitations/api/get-my-invitations";
import { InvitationsList } from "@/app/invitations/list";

const searchSchema = z.object({
  projectId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/invitations/$invitationId"
)({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(myInvitationsQueryOptions);
  },
  loader: () => ({
    crumb: "Invitations",
  }),
  component: InvitationsByIdRouteComponent,
});

function InvitationsByIdRouteComponent() {
  const { invitationId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <InvitationsList
      focusedInvitationId={invitationId}
      projectId={search.projectId}
    />
  );
}
